export const outputTravellers = (travellers) => {
  if (travellers && travellers.length) {
    let tourGroup = ''
    for (let i = 0; i < travellers.length; i++) {
      tourGroup += travellers[i].name
      if (travellers.length > 1 && i < travellers.length - 2) {
        tourGroup += ', '
      } else if (travellers.length > 1 && i === travellers.length - 2) {
        tourGroup += ' and '
      } else {
        tourGroup += ''
      }
    }
    return tourGroup
  }
  return ''
}

export const capitalise = (text) => {
  text = text.toLowerCase()
  const re = /(\b[a-z](?!\s))/g
  const regexText = text.replace(re, (x) => x.toUpperCase())

  return regexText
}

export const definedElementTypeCheck = (service) => {
  if (service && service.definedElementTypes && service.definedElementTypes.length) {
    // Now make sure there is at least one value present in the data object
    const values = []
    service.definedElementTypes.forEach((item) => {
      const tempkeys = Object.keys(item)
      tempkeys.forEach((key) => {
        // Loop through each key and make sure we are not checking for type, serviceType or audit fields along with fields containing empty strings and spaces
        if (item[key] && (item[key] !== '' && item[key] && key !== 'type' && key !== 'serviceType' && key !== 'audit' && item[key].trim().length !== 0)) {
          values.push(item[key])
        }
      })
    })
    if (values && values.length > 0) {
      return true
    }
  }
  return false
}
